import React, { useState, useEffect, useCallback } from 'react';
import { Typography, Box, CircularProgress, useTheme} from '@mui/material';
import {AddBoxOutlined, InstallMobileRounded, IosShareRounded, Visibility, VisibilityOff} from '@mui/icons-material';
import ShowToast from "../components/ToastComponent";
import { LoginSocialGoogle,LoginSocialFacebook } from 'reactjs-social-login';
import { OTPLESS_AUTHENTICATION_SOURCE, OTPLESS_DUROLT_CID, REGEXP_EMAIL, SUCCESS, TOAST_ERROR, TOAST_SUCCESS, TOAST_WARN, BUTTON_PRIMARY, BUTTON_WARNING, HIVEBOARD } from "../assets/constants/Constants";
import {LOGIN, LINK_MY_DEVICE, VERIFY_OTP, HOME, DOOR_VERIFICATION_PAGE, LOCKER_SIZE_SELECTION, USER_ACCOUNT} from '../assets/constants/PageList';
import { useTranslation, Trans } from 'react-i18next';
import {FaceBookIcon, GoogleIcon } from "../assets/constants/Icons";
import ButtonComponent from "../components/ButtonComponent";
import { useHistory } from 'react-router-dom';
import 'react-phone-input-2/lib/material.css';
import { CustomSwitchInput } from '../components/CustomSwitchInput';
import { CustomTextInput } from '../components/CustomTextInput';
import { getSecureItemFromSpecificStorage, storeSecureItemInSpecifiedStorage } from '../lib/BrowserStorageAccessMiddleware';
import { LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS, LS_CUSTOMER, TXN_ID, SS_REDIRECTED_FROM_LOGIN, IS_LOGGED_IN, LS_DOMAIN_AND_LOCKER_BANK, LS_ASSIGNMENT_SLUG, LS_BANKID, IS_OTP_SEND, LS_LOCKER_BANK_INFO, LS_PHONE_PREFIX, LS_PHONE_NUMBER_LENGTH, PERMISSIONS_LIST, ACCESS_GROUP_BANKS, LS_BOOKING_TYPE, ADVANCE_BOOKING } from '../assets/constants/BrowserStorageKeys';
import { handleStoreUserDataInLocalStorage, hasExtraAuthMethods, removeSpacesAndHyphens, getPathForNextPage, GetAvailableLockerSizesAndRedirectUser, getDotCount, handleBulkReservationPayment, getUnitLabelParams } from '../lib/Utils';
import { AnonymousUserAuthentication, registerFacebookLoginUser, registerGoogleLoginUser, sendOtp, verifyWithUserNamePassword, advancereserveLocker, bulkLockerReserver } from '../api/api';
import CircularProgressLoader from '../components/CircularProgressLoader';
import CustomDialog from '../components/CustomDialog';
import CustomQRCodeReader from '../components/CustomQRCodeReader';
import DuroltLogoIcon from "../assets/images/durolt_logo_new.svg";
import OtpInput from '../components/OtpInput';
import { RenderTabs } from '../components/RenderTabsComponent';
import { getDeferredInstallPrompt, clearDeferredInstallPrompt, subscribeToInstallPrompt } from '../lib/InstallPromptManager';

const LoginScreen = () => {
    const history = useHistory();
    const [installAppPrompt, setInstallAppPrompt] = useState(getDeferredInstallPrompt());
    const [showInstallAppModal, setShowInstallAppModal] = useState(false);
    const [isQrCodeReaderVisible, setIsQrCodeReaderVisible] = useState(false);
    const [isDialogVisible, setIsDialogVisible] = useState(false);
    const [dialogContentText, setDialogContentText] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isGoogleLoginLoading, setIsGoogleLoginLoading] = useState(false);
    const [isFacebooLoginkLoading, setIsFacebookLoginLoading] = useState(false);
    const [selCountryLength, setSelCountryLength] = useState(0)
    const [disabled, setDisabled] = useState(true);
    const [errorMessage,setErrorMessage] = useState('');
    const { t } = useTranslation();
    const assignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE,LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
    const [isMobile, setIsMobile] = useState(assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value);
    const [type, setType] = useState(assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value ? 'Mobile' : 'Email');
    const hasSwitchedAuthMethod = assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value && assignmentSettings?.usecase_settings?.verify_with_email_otp_pwa?.value;
    const theme = useTheme();
    const [tabValue, setTabValue] = useState(0);
    const customer = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_CUSTOMER);      
    const [provider, setProvider] = useState('')
    const [profile, setProfile] = useState(null)
    const [showLoader, setShowLoader] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const isLoginWithGoogle = assignmentSettings?.usecase_settings?.login_with_google_pwa?.value; 
    const isLoginWithFacebook = assignmentSettings?.usecase_settings?.login_with_facebook_pwa?.value;
    const isEmailOtpEnabled = assignmentSettings?.usecase_settings?.verify_with_email_otp_pwa?.value;
    const isMobileOtpEnabled = assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value;
    const isUsernamePasswordEnabled = assignmentSettings?.usecase_settings?.verify_with_username_password?.value;
    const assignmentSlug = assignmentSettings?.slug;
    const anonymous_user = assignmentSettings?.usecase_settings?.allow_anonymous_drop_pwa?.value;
    const lockerBankId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK)?.lockerBankId;
    const toShowAuthOptions = assignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value && assignmentSettings?.usecase_settings?.show_pickup_btn_pwa?.value;
    const [showAuthOptions, setShowAuthOptions] = useState(toShowAuthOptions);
    const [isShowLoginField, setIsShowLoginField] = useState(! showAuthOptions);
    const lockerBankInfo = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_LOCKER_BANK_INFO);
    const unitLabelParams = getUnitLabelParams(lockerBankInfo?.LockerBankType, t);
    const[isOTPVerificationFiledEnabled,setIsOTPVerificationFiledEnabled] = useState(false);
    const[isShowSendOTPButtonEnabled,setIsShowSendOTPButtonEnabled] = useState(true);
    const adminTabIndex = (isMobileOtpEnabled ? 1 : 0) + (isEmailOtpEnabled ? 1 : 0);
    const LoginWithUsernamePassword = isUsernamePasswordEnabled && tabValue === adminTabIndex;
    const [username, setUsername] = useState('');
    const [masterPassword, setMasterPassword] = useState('');
    const [showMasterPassword, setShowMasterPassword] = useState(false);
    const { bookingObject, finalGSTObject} = history.location?.state || {};
    const settings = {
        isOTPlessLoginEnabled: false,
        show_otp_inputs_with_tabs : customer === HIVEBOARD ? true : false
    }

    useEffect(() => {
        const isLoggedIn = getSecureItemFromSpecificStorage(LOCAL_STORAGE, IS_LOGGED_IN);
        if (isLoggedIn) {
            history.replace({
                pathname: getPathForNextPage(LOGIN, HOME)
            });
        }
    }, []);

    useEffect(() => {
        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_BANKID, lockerBankId);
        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_ASSIGNMENT_SLUG, assignmentSlug);

        return subscribeToInstallPrompt(setInstallAppPrompt);
    }, []);

    const toggleInput = (value) => {
        setMobile('');
        setEmail('');
        setUsername('');
        setMasterPassword('');
        setShowMasterPassword(false);
        setErrorMessage('');

        if (isUsernamePasswordEnabled && value === adminTabIndex) {
            setIsMobile(false);
            setType('Admin');
        } else if (isMobileOtpEnabled && value === 0) {
            setIsMobile(true);
            setType('Mobile');
        } else {
            setIsMobile(false);
            setType('Email');
        }
        setIsOTPVerificationFiledEnabled(false);
        setIsShowSendOTPButtonEnabled(true);
    };

    const handleSetUsername = (e) => {
        setUsername(e.target.value);
    };

    const handleSetMasterPassword = (e) => {
        setMasterPassword(e.target.value);
    };

    const handleAdminLogin = async () => {
        try {
            setIsLoading(true);
            const body = {
                username: username.trim(),
                password: masterPassword,
            };
            const response = await verifyWithUserNamePassword(body);
            if (response?.status === SUCCESS) {
                setIsLoading(false);
                let userInfo = response?.data;
                const permissionsList = userInfo?.permission_list;
                const accessGroupBanks = userInfo?.access_group_banks;
                if(permissionsList){
                storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, PERMISSIONS_LIST, permissionsList);
                }
                if(accessGroupBanks){
                storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, ACCESS_GROUP_BANKS, accessGroupBanks);
                }
                handleStoreUserDataInLocalStorage(userInfo);
                const bookingtype = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_BOOKING_TYPE);
                if (bookingObject && bookingtype === ADVANCE_BOOKING) {
                    if (!assignmentSettings?.is_pricing) {
                        ShowToast(t('msg_success_otp_verified_wait_for_reservation'), TOAST_SUCCESS);
                    } else {
                        ShowToast(t('msg_success_otp_successfull_wait_for_reservation_and_payment'), TOAST_SUCCESS);
                    }
                    try {
                        setLoadingMessage(t('pleaseWaitText'));
                        setShowLoader(true);
                        const reserveLockerResponse = await advancereserveLocker(bookingObject);

                        if (reserveLockerResponse?.data?.status === "success") {
                            if (!assignmentSettings?.is_pricing) {
                                ShowToast(t('msg_success_locker_reservation_redirect_to_profile'), TOAST_SUCCESS);
                                history.push(getPathForNextPage(LOGIN, USER_ACCOUNT));
                            } else {
                                ShowToast(t('msg_success_Locker_reserved_wait_for_payment', unitLabelParams), TOAST_SUCCESS);
                                await handleBulkReservationPayment(reserveLockerResponse, history, finalGSTObject, { isAdvanceBooking: true });
                            }
                        }
                    } catch (error) {
                        console.error('Error while reserving locker after admin login:', error);
                        history.push(getPathForNextPage(LOGIN, HOME));
                    } finally {
                        setShowLoader(false);
                    }
                    return;
                }

                if (bookingObject) {
                    if (!assignmentSettings?.is_pricing) {
                        ShowToast(t('msg_success_otp_verified_wait_for_reservation'), TOAST_SUCCESS);
                    } else {
                        ShowToast(t('msg_success_otp_successfull_wait_for_reservation_and_payment'), TOAST_SUCCESS);
                    }
                    try {
                        setLoadingMessage(t('pleaseWaitText'));
                        setShowLoader(true);
                        const reserveLockerResponse = await bulkLockerReserver(bookingObject);

                        if (reserveLockerResponse?.data?.status === "success") {
                            if (!assignmentSettings?.is_pricing) {
                                ShowToast(t('msg_success_locker_reservation_redirect_to_profile'), TOAST_SUCCESS);
                                history.push(getPathForNextPage(LOGIN, USER_ACCOUNT));
                            } else {
                                ShowToast(t('msg_success_Locker_reserved_wait_for_payment', unitLabelParams), TOAST_SUCCESS);
                                await handleBulkReservationPayment(reserveLockerResponse, history, finalGSTObject, { isAdvanceBooking: false });
                            }
                        }
                    } catch (error) {
                        console.error('Error while reserving locker after admin login:', error);
                        history.push(getPathForNextPage(LOGIN, HOME));
                    } finally {
                        setShowLoader(false);
                    }
                    return;
                }

                history.push(getPathForNextPage(LOGIN, HOME));
            } else {
                setIsLoading(false);
                ShowToast(response?.message, TOAST_ERROR);
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error while verifying username and password:', error);
            ShowToast(error?.message, TOAST_ERROR);
        }
    };

    const getToken = async () => {
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === 'false' || isLoggedIn === null) {
            localStorage.removeItem('token');
        }
    };

    useEffect(() => {

        if (settings?.isOTPlessLoginEnabled) {
            constructAndAppendOTPlessScriptElement();
        }
        getUserDetailsAfterOTPlessAuthentication();
        getToken();
    }, []);

    const onLoginStart = useCallback(() => {
        setLoadingMessage(t('pleaseWaitText'));
        setShowLoader(true);
      }, [])

      const onLogoutSuccess = useCallback(() => {
        setProfile(null)
        setProvider('')
        alert('logout success')
      }, [])

    const constructAndAppendOTPlessScriptElement = () => {
        const otplessScriptElement = document.createElement("script");
        otplessScriptElement.src = OTPLESS_AUTHENTICATION_SOURCE;
        otplessScriptElement.cid = OTPLESS_DUROLT_CID;
        otplessScriptElement.id = "otpless-script";

        const otplessLoginPageElement = document.getElementById("otpless-login-page");
        otplessLoginPageElement.appendChild(otplessScriptElement);
    }

    const getUserDetailsAfterOTPlessAuthentication = () => {
        window.otpless = (otplessUserDetails) => {
            alert("Auth page OTPLess alert:" + JSON.stringify(otplessUserDetails));
            if (settings?.isOTPlessLoginEnabled) { removeOTPlessScriptAndWidgetWhenRedirectingToAnotherPage() }
            history.push({ pathname: getPathForNextPage(HOME, LOCKER_SIZE_SELECTION) });
        }
    }

    const removeOTPlessScriptAndWidgetWhenRedirectingToAnotherPage = () => {
        document.getElementById("otpless-script")?.remove();
        document.getElementById("otpless-floating-button")?.remove();
        document.getElementById("otpless-loader-style")?.remove();
    }
    const validation = () => {
        if (isLoading) {
            return;
        }
        const isMobileValid = () => {
            if (mobile.trim() === '') {
                ShowToast(t('LoginPhoneError'), TOAST_WARN);
                return false;
            }
            return true;
        };
   
        const isEmailValid = () => {
            if (email.trim() === '') {
                ShowToast(t('LoginEmailError'), TOAST_WARN);
                return false;
            } else if (!REGEXP_EMAIL.test(email.trim())) {
                ShowToast(t('OTPSentEmailFailed'), TOAST_ERROR);
                return false;
            }
            return true;
        };

        if (type === 'Mobile') {
            if (isMobileValid()) {
                let mobileNumber = removeSpacesAndHyphens(mobile);
                return sendOTPRequest(mobileNumber, 'phone');
            }
        } else if (isEmailValid()) {
            return sendOTPRequest(email, 'email');
        }
    };

    const sendOTPRequest = async (userInput,toggle) => {
        try {
            if(assignmentSettings && userInput !== ''){
                setIsLoading(true);
                let assignmentSlug = assignmentSettings?.slug;
                const response = await sendOtp(userInput,assignmentSlug);
                if (response.status == SUCCESS) {
                    let txnId = response?.data?.txn_id;
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, TXN_ID, txnId);
                    setIsLoading(false);
                    let isOTPSend = response?.data?.is_otp_sent
                    if(isOTPSend){
                        ShowToast(t('OTPSentSuccessfully'), TOAST_SUCCESS); 
                    }else{
                        ShowToast(t('sameOtp'), TOAST_SUCCESS);
                    }
                    {
                        customer !== HIVEBOARD &&
                        setIsOTPVerificationFiledEnabled(true)
                        setIsShowSendOTPButtonEnabled(false)
                    }
                    storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, IS_OTP_SEND, isOTPSend);
                    {
                        customer === HIVEBOARD &&
                        history.push(getPathForNextPage(LOGIN, VERIFY_OTP), { userInput: userInput, toggle: toggle })
                    }
                } else {
                    setIsLoading(false);
                    ShowToast(toggle === 'Mobile' ? t('OTPSentPhoneFailed') : t('OTPSentEmailFailed'), TOAST_ERROR);
                }
            }
        } catch (error) {
            setIsLoading(false);
            console.error('Error while sending OTP:', error);

            if (error?.response?.status === 406 && error?.response?.data?.message?.includes('Invalid Data')) {
                const errorMessage = `${t('Error_Send_OTP')} ${/\+\d+/.test(userInput) ? t('phoneNumberLabel') : t('emailAddressLabel')}.`;
                ShowToast(errorMessage, TOAST_ERROR);
            }
        }
    };


    const qrCodeReaderScanHandler = async (qrCodeData) => {
        try {
            if (qrCodeData && qrCodeData.length > 0) {
                const qrCodeLink = qrCodeData[0]?.rawValue;
                const pathnameWithTrailingSlash = `${getPathForNextPage(LOGIN, LINK_MY_DEVICE)}/`;
                const doPwaDomainAndQrCodeLinkDomainMatch = (pwaEnvironment) => {
                    if (pwaEnvironment === 'prod' && qrCodeLink.includes('app.durolt.com')) {
                        return true;
                    }
                    if (pwaEnvironment === 'uat' && qrCodeLink.includes('appdemo.durolt.in')) {
                        return true;
                    }
                    if ((pwaEnvironment === 'dev' || pwaEnvironment === 'local') && qrCodeLink.includes('app.durolt.in')) {
                        return true;
                    }

                    return false;
                }

                if ( !(qrCodeLink.includes(pathnameWithTrailingSlash)) || !(doPwaDomainAndQrCodeLinkDomainMatch(process.env.REACT_APP_ENV)) ) {
                    setDialogContentText(t('Invalid_QR_Link_My_Phone'));
                    setIsDialogVisible(true);
                    setIsQrCodeReaderVisible(false);
                    return;
                }

                const startIndex = qrCodeLink.indexOf(pathnameWithTrailingSlash);
                const base64StringWithTrailingSlash = qrCodeLink.substring(startIndex + pathnameWithTrailingSlash.length);
                const redirectionPathWithParameter = `${pathnameWithTrailingSlash}${base64StringWithTrailingSlash}`;
                

                history.push({
                    pathname: redirectionPathWithParameter
                });
            }
        } catch (error) {
            console.error('Error while scanning link my device QR code: ', error);
            setDialogContentText(t('Error_Link_MyPhone'));
            setIsDialogVisible(true);
            setIsQrCodeReaderVisible(false);
        }
    };

    const qrCodeReaderErrorHandler = async (error) => {
        console.error('Error while scanning link my device QR code: ', error);
    }

    const handleSetMobile = (value, country, e) => {
        const phoneNumber = e.target.value;
        let phonePrfix = country.format[0]+country.dialCode;
        const format = country.format;
        const sliced = format.slice(format.indexOf(" ") + 1);
        const dotCount = getDotCount(sliced);
        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PHONE_PREFIX, phonePrfix);
        storeSecureItemInSpecifiedStorage(LOCAL_STORAGE, LS_PHONE_NUMBER_LENGTH, dotCount);
        if (phoneNumber) {
            setSelCountryLength(country.format.length);
            setMobile(phoneNumber);
            const isValidPhoneNumber = phoneNumber.length > 8 ? true : false;

            if (!isValidPhoneNumber) {
                setErrorMessage(t('LoginPhoneError'));
            } else {
                setErrorMessage('');
            }
            setDisabled(!isValidPhoneNumber);
        }
    };

    const handleSetEmail = (e) => {
        const email = e.target.value;
        setEmail(email);

        if (!REGEXP_EMAIL.test(email)) {
            setErrorMessage(t('LoginEmailError'));
        } else {
            setErrorMessage('');
        }
        setDisabled(!REGEXP_EMAIL.test(email));
    };

    const handleChange = (newValue) => {
        setTabValue(newValue);
        toggleInput(newValue);
    };

    const handleRegisterGoogleUser = async (userData) => {
        try {
            const googleAccessToken = userData?.access_token;
            const email = userData?.email
            if (googleAccessToken && email) {
                const response = await registerGoogleLoginUser(googleAccessToken, assignmentSlug, email);
                if (response.status === SUCCESS) {
                    setShowLoader(false);
                    let userInfo = response?.data
                    handleStoreUserDataInLocalStorage(userInfo)
                    sessionStorage.setItem(SS_REDIRECTED_FROM_LOGIN, true);
                    history.push(getPathForNextPage(LOGIN, HOME));
                } else {
                    setShowLoader(false);
                }
            } else {
                setShowLoader(false);
            }
        } catch (error) {
            setShowLoader(false);
            console.error("Error while registering Google user:", error);
        }
    }

    const handleRegisterFacebookUser = async (userData) => {
        try {
            const faceBookAuthToken = userData?.accessToken;
            const email = userData?.email
            if (faceBookAuthToken && email) {
                const response = await registerFacebookLoginUser(faceBookAuthToken, assignmentSlug, email);
                if (response.status === SUCCESS) {
                    setShowLoader(false);
                    let userInfo = response?.data
                    handleStoreUserDataInLocalStorage(userInfo)
                    sessionStorage.setItem(SS_REDIRECTED_FROM_LOGIN, true);
                    history.push(getPathForNextPage(LOGIN, HOME));
                } else {
                    setShowLoader(false);
                }
            } else {
                setShowLoader(false);
            }
        } catch (error) {
            setShowLoader(false);
            console.error("Error while registering Google user:", error);
        }
    }

    const handleInstallAppButtonClick = async () => {
        const userAgent = navigator.userAgent;
        const isAppleDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        const isSafariBrowser = /Safari/.test(userAgent) && !/Chrome/.test(userAgent);

        if (isAppleDevice && isSafariBrowser) {
            setShowInstallAppModal(true);
        }
        else if (installAppPrompt) {
            try {
                installAppPrompt.prompt();

                clearDeferredInstallPrompt();
            } catch (error) {
                console.error('Install app prompt error: ', error);
            }
        }
        else if (window.matchMedia('(display-mode: standalone)').matches) {
            alert(t('Already_Installed'));
        }
        else {
            alert(t('Install_Not_Available'));
        }
    };

    const renderInstallAppModalContent = () => {
        return (
            <Box className='modal-content'>
                <Typography className='install-text'>{t('ios_install_instructions_title')}</Typography>
                <Box className='instructions-list'>
                    <Typography className='instruction'>
                        <Trans
                            i18nKey="ios_install_step_1"
                            components={{
                                b: <b />,
                                shareIcon: <IosShareRounded className='instruction-icon' />,
                            }}
                        />
                    </Typography>
                    <Typography className='instruction'>
                        <Trans
                            i18nKey="ios_install_step_2"
                            components={{
                                b: <b />,
                                addIcon: <AddBoxOutlined className='instruction-icon' />,
                            }}
                        />
                    </Typography>
                    <Typography className='instruction'>
                        <Trans i18nKey="ios_install_step_3" components={{ b: <b /> }} />
                    </Typography>
                </Box>
            </Box>
        );
    };
    const handleDropUser = async()=>{
        if(anonymous_user){
            try{
                const response = await AnonymousUserAuthentication(assignmentSlug);
                if(response?.data){
                    const UserData = response.data
                    handleStoreUserDataInLocalStorage(UserData);
                    await GetAvailableLockerSizesAndRedirectUser(lockerBankInfo,lockerBankId,UserData?.id, assignmentSettings?.is_pricing, history); 
                }
            }
            catch(error){
                console.error(`error during calling the AnonymousUserAuthentication api`);
            }
        }
        else{
            setIsShowLoginField(true);
        }
        setShowAuthOptions(false);  
    }
    const handlePickupUser = ()=>{
        history.push(getPathForNextPage(LOGIN, DOOR_VERIFICATION_PAGE));
    }
    const renderAuthenticationOption = ()=>{
        return(
            <div className='all-authentication-buttons-container'>
                <div className='main'>
                {
                    assignmentSettings?.usecase_settings?.show_drop_btn_pwa?.value && 
                    <ButtonComponent className="drop-button-class" title={'button_dropUser'} handleClick={handleDropUser}/>
                }
                {
                    assignmentSettings?.usecase_settings?.show_pickup_btn_pwa?.value &&
                    <ButtonComponent className='pickup-button-class' title={'button_pickUser'} handleClick={handlePickupUser}/>
                }
                </div>
            </div>
        )
    }

        return (
        <Box className={`login-screen-page ${t("backgroundImage") ? 'img' : ''}`}
         sx={{backgroundImage : t("backgroundImage") ? `url(${t("backgroundImage")})` : ""}}
        >
        {
            showAuthOptions  ?
            renderAuthenticationOption()
            :
            isShowLoginField  ?
            <Box className='main-container'>
                {isQrCodeReaderVisible ? (
                    <Box className='main'>
                        <Box className='qr-code-reader'>
                            <CustomQRCodeReader
                                handleOnScan={qrCodeReaderScanHandler}
                                handleOnError={qrCodeReaderErrorHandler}
                            />
                            <Typography className='qr-code-heading'>{t('Scan_QR_To_Link_Device')}</Typography>
                            <ButtonComponent handleClick={() => setIsQrCodeReaderVisible(false)} title={'button_cancel'} type={BUTTON_WARNING} />
                        </Box>
                    </Box>
                ) : (
                    <Box className='main'>
                        <Box className="logo_style">
                            {t("logo") !== "logo" ? <img  height={"auto"} width={120} src={t("logo")}/> :
                            <img src={DuroltLogoIcon} width={160} alt="Durolt Logo" />}
                        </Box>
                        <div className="formView">
                            <h2 className='text' style={{fontSize:28}}> {t('loginTitle', unitLabelParams)} </h2>
                            <p className='anotherText' style={{fontSize:12, marginTop:-5, marginBottom:20}}> {t('loginText', unitLabelParams)} </p>
                            <div className='input-tab-bar-container'>
                            <RenderTabs
                                tabs={[
                                    { enabled: isMobileOtpEnabled, label: "phoneNumberLabel" },
                                    { enabled: isEmailOtpEnabled, label: "emailAddressLabel" },
                                    { enabled: isUsernamePasswordEnabled, label: "Username" },
                                ]}
                                tabValue={tabValue}
                                onChange={handleChange}
                                t={t}
                                customer={customer}
                            />
                            </div>
                                {LoginWithUsernamePassword ?
                                <>
                                <div className="inputContainer">
                                    <CustomTextInput
                                        className="emailInput"
                                        autoFocus={true}
                                        placeholder={t('enterUsernameLabel')}
                                        type="text"
                                        onChange={handleSetUsername}
                                        value={username}
                                        text={t('enterUsernameLabel')}
                                    />
                                    <CustomTextInput
                                        className="emailInput"
                                        placeholder={t('enterMasterPasswordLabel')}
                                        type={showMasterPassword ? 'text' : 'password'}
                                        onChange={handleSetMasterPassword}
                                        value={masterPassword}
                                        autoFocus={false}
                                        text={t('enterMasterPasswordLabel')}
                                        endIcon={showMasterPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                        onEndIconClick={() => setShowMasterPassword((prev) => !prev)}
                                    />
                                </div>
                                <Box className="login-button">
                                    <ButtonComponent align="right" type="custom" handleClick={handleAdminLogin} title={isLoading ? '' : 'button_login'} disabled={!username.trim() || !masterPassword.trim()} />
                                </Box>
                                </>
                                :
                                (assignmentSettings?.usecase_settings?.verify_with_mobile_otp_pwa?.value || assignmentSettings?.usecase_settings?.verify_with_email_otp_pwa?.value) &&
                                <>
                                <CustomSwitchInput
                                    isMobile={isMobile}
                                    mobile={mobile}
                                    email={email}
                                    handleSetMobile={handleSetMobile}
                                    toggleInput={toggleInput}
                                    handleSetEmail={handleSetEmail}
                                    validation={validation}
                                    error={!!errorMessage}
                                    hasSwitchedAuthMethod={hasSwitchedAuthMethod}
                                    disabled={disabled}
                                    enableTabs={settings?.show_otp_inputs_with_tabs}
                                />
                            {errorMessage && <Typography className="login-error-message">{errorMessage}</Typography>}
                            <Box className="login-button">
                                {isShowSendOTPButtonEnabled && customer !== HIVEBOARD && 
                                <ButtonComponent  align="right"  type="custom" handleClick={validation} title={isLoading ? '' : 'loginBtnText'}  disabled={customer === "Durolt" && disabled} />
                                }
                                {
                                    customer === HIVEBOARD && isShowSendOTPButtonEnabled &&
                                    <div className= 'otpsendButton'>
                                    <ButtonComponent   handleClick={validation} title={isLoading ? <CircularProgress size={24} /> : 'loginBtnText'}
                                    />
                                    </div>
                                }
                            </Box>
                            </>
                            }
                            
                             {isOTPVerificationFiledEnabled && 
                            <OtpInput 
                            bookingObject = {bookingObject}
                            finalGSTObject = {finalGSTObject}
                            length={4}  userInput={mobile ? mobile : email} />}

                            {(hasExtraAuthMethods(assignmentSettings?.usecase_settings) || isLoginWithGoogle && isLoginWithFacebook) &&
                            <>
                                <div className='textORMainContainer'>
                                    <div className='textORLine' />
                                        <div className='textORContainer'>
                                            <p className='shareText'>
                                            {t('orText')}
                                            </p>
                                        </div>
                                    <div className='textORLine' />
                                </div>
                                
                            <LoginSocialGoogle
                                client_id={process.env.REACT_APP_GG_APP_ID || ''}
                                scope="openid profile email"
                                onLoginStart={onLoginStart}
                                onResolve={({ provider, data }) => {
                                    setProvider(provider);
                                    setProfile(data);
                                    handleRegisterGoogleUser(data)
                                }}
                                onReject={(err) => {
                                    setShowLoader(false);
                                    console.log("Error", err);
                                }}>
                                {isLoginWithGoogle && <ButtonComponent buttonId='login-with-google-button' handleClick={() => { }} title={isGoogleLoginLoading ? <CircularProgress size={24} /> : t("loginWithGoogleLabel")} disabled={null} customClass='blurred' startIcon={<GoogleIcon />} />}
                            </LoginSocialGoogle>

                            <LoginSocialFacebook
                                appId={process.env.REACT_APP_FB_APP_ID || ''}
                                onLoginStart={onLoginStart}
                                onResolve={({ provider, data }) => {
                                    setProvider(provider)
                                    setProfile(data)
                                    handleRegisterFacebookUser(data)
                                }}
                                onReject={(err) => {
                                    setShowLoader(false);
                                    console.log(err)
                                }}
                            >
                            {isLoginWithFacebook && <ButtonComponent buttonId='login-with-facebook-button' handleClick={() => {}} title={isFacebooLoginkLoading ? <CircularProgress size={24} /> : t("loginWithFacebookLabel")} disabled={null} customClass='blurred' startIcon={<FaceBookIcon />} />}
                            </LoginSocialFacebook>
                                {assignmentSettings?.usecase_settings?.link_my_device?.value &&
                                <ButtonComponent buttonId='link-my-device-button' handleClick={() => setIsQrCodeReaderVisible(true)} title={'scanBtnText'} type='default' />}
                            </>
                        }
                        </div>


                        {settings?.isOTPlessLoginEnabled && (
                            <Box className="otpless-login-page-container">
                                <Box id="otpless-login-page"></Box>
                            </Box>
                        )}
                        <div className="login-footer">
                            <ButtonComponent
                                buttonId='install-app-button'
                                handleClick={handleInstallAppButtonClick}
                                title={'Install_App'}
                                startIcon={<InstallMobileRounded />}
                                type={'iceBlue'}
                            />
                            <Box className="loginPageFooterText">
                                <Typography className='footerTextStyle'>
                                    {t('appVersionText')} {process.env.REACT_APP_RELEASE_VERSION}
                                </Typography>
                            </Box>
                        </div>
                    </Box>
                )}
                <CustomDialog
                    dialogId='error-dialog'
                    dialogVisible={isDialogVisible}
                    dialogTitle={t('page_title_error')}
                    dialogContentText={dialogContentText}
                    buttonTwoTitle={t('button_ok')}
                    buttonProps={{ buttonTwo: { type: BUTTON_PRIMARY } }}
                    handleAccept={() => setIsDialogVisible(false)}
                />
                <CustomDialog
                    dialogId='install-app-instructions-modal'
                    dialogVisible={showInstallAppModal}
                    dialogTitle={t('Install_App')}
                    children={renderInstallAppModalContent}
                    buttonTwoTitle={t('button_ok')}
                    buttonProps={{buttonTwo: {type: BUTTON_PRIMARY}}}
                    handleAccept={() => setShowInstallAppModal(false)}
                    onClose={() => setShowInstallAppModal(false)}
                />
            </Box> : null 
        }
            
            {showLoader && (<CircularProgressLoader message={loadingMessage} />)}
        </Box>
    );
};

export default LoginScreen;
